export default "__VITE_ASSET__Oty1n1GG__"